<template>
  <div v-if="currentUser" class="announcements-verify-admin">
    <div class="page-header">
      <h1>Weryfikowanie ogłoszeń</h1>
      <button class="btn-outline" @click="resetSearch">Resetuj filtry</button>
    </div>

    <div class="section-card">
      <div class="section-card-header">
        <h2>Wyszukiwanie ogłoszeń</h2>
        <div class="search-bar">
          <input
              type="text"
              placeholder="Szukaj po tytule..."
              v-model="searchInput"
              @keyup.enter="searchAnnouncement"
          >
          <button @click="searchAnnouncement" class="btn-green">Szukaj</button>
          <button @click="resetSearch" class="btn-outline">Resetuj</button>
        </div>
      </div>

      <div class="toolbar-row">
        <div class="results-chip">Wyniki: <b>{{ announcementsCount || 0 }}</b></div>
        <div class="pagination">
          <button class="btn-outline" @click="prevPage" :disabled="page <= 1">
            &#8592; Poprzednia
          </button>
          <span class="page-info">Strona {{ page }} / {{ totalPages }}</span>
          <button class="btn-outline" @click="nextPage" :disabled="page >= totalPages">
            Następna &#8594;
          </button>
        </div>
      </div>
    </div>

    <div class="section-card cards-card position-relative">
      <HintComponent page-key="admin_panel_announcements_verify" :absolute="true"/>
      <div class="section-card-header">
        <h2>Lista ogłoszeń</h2>
      </div>

      <div class="announcements-container" v-if="announcements.length > 0">
        <AnnouncementCardVue
            v-for="announcement in announcements.slice(0, 50)"
            :key="announcement.id"
            :showActive="true"
            :showVerify="true"
            :active="announcement.active"
            :contact="announcement.contact"
            :target="announcement.target"
            :category="announcement.category"
            :img="announcement.photo_url"
            :longContent="announcement.description"
            :id="announcement.id"
            :title="announcement.title"
            :content="announcement.short_description"
            :photo="announcement.photo"
            :removable="true"
            @verifyAnnouncement="(id) => verifyAnnouncement(id)"
            @deleteAnnouncement="(id) => deleteAnnouncement(id)"
        />
      </div>

      <div v-else class="empty-state">
        <p>Nie znaleziono ogłoszeń.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AnnouncementCardVue from '@/components/SpecialComponents/AnnouncementCard.vue';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'AnnouncementsVerify',
  components: {HintComponent, AnnouncementCardVue },
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    };
  },
  data() {
    return {
      announcements: [],
      announcementsCount: null,
      searchInput: '',
      page: 1,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
    totalPages() {
      const pages = Math.ceil((this.announcementsCount || 0) / 100);
      return pages > 0 ? pages : 1;
    },
  },
  mounted() {
    if (!this.currentUser) {
      this.$router.push('/login');
    } else if (this.currentUser.role_id !== 1) {
      this.$router.push('/login');
    }
    this.getAnnouncements();
  },
  methods: {
    searchAnnouncement() {
      if (this.searchInput.length > 2) {
        axios.post('/AnnouncementSearch', {
          page: 1,
          limit: 1000,
        }).then(res => {
          if (res.data.count > 1000) {
            axios.post('/AnnouncementSearch', {
              page: 1,
              limit: res.data.count,
            }).then(resp => {
              this.announcements = resp.data.items.filter(item => item.title.toLowerCase().includes(this.searchInput.toLowerCase()));
              this.announcementsCount = this.announcements.length;
              this.page = 1;
            });
          } else {
            this.announcements = res.data.items.filter(item => item.title.toLowerCase().includes(this.searchInput.toLowerCase()));
            this.announcementsCount = this.announcements.length;
            this.page = 1;
          }
        });
      } else {
        this.appStore.setIsAlert('Wpisz co najmniej 3 litery');
      }
    },
    getAnnouncements() {
      this.announcements = [];
      const ob = {
        page: this.page,
        limit: 100,
      };
      axios.post('/AnnouncementSearch', ob).then(res => {
        this.announcementsCount = res.data.count;
        res.data.items.forEach(item => {
          const freshAnnouncement = {
            title: item.title,
            description: item.description,
            id: item.id,
            photo_url: item.photo_url,
            short_description: item.short_description,
            target: item.target,
            category: item.category,
            contact: item.contact,
            active: item.active,
          };
          this.announcements.push(freshAnnouncement);
        });
      });
    },
    resetSearch() {
      this.searchInput = '';
      this.page = 1;
      this.getAnnouncements();
    },
    prevPage() {
      if (this.page > 1) {
        this.page -= 1;
        this.getAnnouncements();
      }
    },
    nextPage() {
      if (this.page < this.totalPages) {
        this.page += 1;
        this.getAnnouncements();
      }
    },
    deleteAnnouncement(id) {
      axios.delete(`/Announcement/${id}`, authHeader()).then(res => {
        if (String(res.status).charAt(0) == '2') {
          this.appStore.setIsSuccess('Pomyślnie usunięto ogłoszenie');
          this.getAnnouncements();
        }
      }).catch(() => {});
    },
    verifyAnnouncement(data) {
      axios.get(`/AnnouncementEnableByAdmin/${data.id}`, authHeader())
          .then(res => {
            if (String(res.status).charAt(0) == '2') {
              this.appStore.setIsSuccess('Pomyślnie zweryfikowano ogłoszenie');
              this.getAnnouncements();
            }
          }).catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.announcements-verify-admin {
  max-width: 1200px;
  margin: 0 auto;
  padding: 32px 16px;
  font-family: sans-serif;
  box-sizing: border-box;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid #e5e7eb;
}

.page-header h1 {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.section-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08);
  padding: 24px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 20px;
}

.section-card-header {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 14px;
}

.section-card h2 {
  font-size: 2rem;
  font-weight: 700;
  color: #1f2937;
  margin: 0;
}

.search-bar {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.search-bar input {
  flex: 1 1 240px;
  min-width: 0;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 1.5rem;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
}

.search-bar input:focus {
  border-color: #10b981;
}

.toolbar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 8px;
  border-top: 1px solid #e5e7eb;
}

.results-chip {
  font-size: 1.4rem;
  color: #374151;
  background: #f3f4f6;
  border-radius: 999px;
  padding: 6px 12px;
}

.pagination {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}

.page-info {
  font-size: 1.5rem;
  color: #6b7280;
  font-weight: 500;
  min-width: 130px;
  text-align: center;
}

.cards-card {
  margin-bottom: 0;
}

.announcements-container {
  margin-top: 6px;
  display: grid;
  justify-content: center;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  flex-wrap: wrap;
}

.empty-state {
  text-align: center;
  padding: 28px;
  color: #9ca3af;
  font-size: 1.5rem;
  border: 1px dashed #d1d5db;
  border-radius: 10px;
}

.btn-primary {
  background-color: #f97316;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  font-size: 1.35rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-primary:hover {
  background-color: #ea6c0a;
}

.btn-green {
  background-color: #10b981;
  color: #fff;
  padding: 8px 14px;
  border-radius: 8px;
  border: none;
  font-size: 1.35rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.btn-green:hover {
  background-color: #059669;
}

.btn-outline {
  background-color: transparent;
  color: #1f2937;
  padding: 8px 14px;
  border-radius: 8px;
  border: 1px solid #d1d5db;
  font-size: 1.35rem;
  cursor: pointer;
  transition: border-color 0.2s, color 0.2s;
}

.btn-outline:hover {
  border-color: #10b981;
  color: #10b981;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

@media (max-width: 900px) {
  .toolbar-row {
    flex-direction: column;
    align-items: stretch;
  }

  .pagination {
    justify-content: space-between;
  }
}

@media (max-width: 768px) {
  .announcements-container {
    grid-template-columns: auto;
  }

  .search-bar input {
    flex: auto;
  }
}

@media (max-width: 480px) {
  .announcements-verify-admin {
    padding: 16px 12px;
  }

  .page-header h1 {
    font-size: 2.2rem;
  }

  .section-card {
    padding: 16px 12px;
    border-radius: 8px;
  }

  .section-card h2 {
    font-size: 1.8rem;
  }

  .search-bar {
    flex-direction: column;
  }

  .search-bar input,
  .btn-green,
  .btn-outline {
    width: 100%;
    text-align: center;
  }
}
</style>